export const selectVideoId = ({eventDetails}) => eventDetails?.videoId;
export const selectEventType = ({eventDetails}) => eventDetails.eventType || '';
